"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
// Episerver library
const spa_core_1 = require("@episerver/spa-core");
// Modules
const foundation_settings_1 = require("@episerver/foundation-settings");
// Referenced components for configuration
const LoadingSpinner_1 = __importDefault(require("app/Components/Shared/LoadingSpinner"));
const SampoLayout_1 = __importDefault(require("app/Components/Shared/SampoLayout"));
// Referenced implementation
//import MoseyComponentLoader from "app/Infrastructure/ComponentLoader";
// Enable caching of action calls
// ContentDelivery.FetchAdapter.isCachable.push(url => url.pathname.indexOf('/api/episerver/v3/action/') >= 0 && !url.searchParams.has('epieditmode') && !url.searchParams.has('EpiEditMode'));
const appDebug = process.env.NODE_ENV === 'development';
const defaultFadeAnimation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { ease: 'linear', duration: 0.3 }
};
// Website configuration
exports.Config = {
    // Main setup
    enableDebug: appDebug,
    // Connection details
    basePath: process.env.WEB_PATH,
    epiBaseUrl: process.env.EPI_URL,
    defaultLanguage: 'en',
    defaultLanguageWithoutPrefix: true,
    // Site layout
    layout: SampoLayout_1.default,
    // Spinner section
    enableSpinner: true,
    spinner: LoadingSpinner_1.default,
    spinnerTimeout: 250,
    // Content area configuration
    contentArea: {
        displayOptions: {
            'displaymode-layout-rn-full': 'layout col-12 r-narrow',
            'displaymode-layout-rn-half': 'layout col-12 col-sm-6 r-narrow',
            'displaymode-layout-full': 'layout col-12',
            'displaymode-layout-half': 'layout col-12 col-sm-6',
            'displaymode-layout-three-quarters-on-right': 'layout col-12 col-sm-8 offset-sm-4',
            'displaymode-size-of-content': 'col-auto',
            'displaymode-full': 'col-12',
            'displaymode-wide': 'col-12 col-sm-8',
            'displaymode-wide-right': 'col-12 col-sm-8 offset-sm-4',
            'displaymode-half': 'col-12 col-sm-6',
            'displaymode-narrow': 'col-12 col-sm-4',
            'displaymode-one-quarter': 'col-12 col-sm-6 col-md-3',
            'displaymode-three-quarters': 'col-12 col-sm-8'
        },
        defaultRowClass: 'row g-0 overflow-hidden',
        defaultBlockClass: 'col-12',
        defaultContainerClass: 'container',
        containerBreakBlockClass: 'displaymode-screen',
        animationOptions: defaultFadeAnimation
    },
    // (Pre)Loading of components, pre-load those components that make up your key landing pages
    preLoadComponents: [
        'app/Components/Shared/PageTop',
        'app/Components/Shared/Glossary',
        'app/Components/Shared/Navigation',
        'app/Components/Shared/Header',
        'app/Components/NavigationTree/NavigationItem',
        'app/Components/NavigationTree/NavigationTree',
        'app/Components/Shared/Footer',
        'app/Components/Page/HomePage',
        'app/Components/Page/LandingPage',
        'app/Components/Page/ReportPage',
        'app/Components/Block/Image/Media/ImageMediaData',
        'app/Components/Image/Media/ImageMediaData',
        'app/Components/Image/Media/VectorImageMediaData',
        'app/Components/Block/HeroBlock',
        'app/Components/Block/TextBlock',
        'app/Components/Block/ContainerBlock',
        'app/Components/Block/OnPageNavigationBlock',
        'app/Components/Block/FrontpageMediaLiftupBlock',
        'app/Components/Block/FullWidthHighLightBlock',
        'app/Components/Block/FrontpageShortcutBlock',
        'app/Components/Block/TwoColContentBlock',
        'app/Components/Block/ImageAndDetailsBlock',
        'app/Components/Block/SampoLinkBlock',
        'app/Components/Block/CEOReviewHeroBlock',
        'app/Components/Common/Link',
        'app/Components/Block/ArmpitLiftUpBlock',
        'app/Components/Block/LatestNewsBlock'
    ],
    // List SPA Modules that inject into the bootstrapping process
    modules: [
        new foundation_settings_1.SettingsInitialization()
    ],
    // List of custom component loaders, app/Components is handled by the core library,
    // so the MoseyComponentLoader is here as example.
    componentLoaders: [
    /*MoseyComponentLoader*/
    ],
    // Configuration of the V2 Content Repository
    iContentRepository: {
        debug: appDebug,
        policy: spa_core_1.ContentDelivery.IRepositoryPolicy.LocalStorageFirst
    },
    // Configuration of the V2 Content Delivery API, this overrides the old configuration
    iContentDelivery: {
        Debug: false,
        AutoExpandAll: false,
    },
    routes: []
};
exports.Config.componentLoaders.debug = false; // Override global debug to disable debug within the component loaders
exports.default = exports.Config;
